/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react"
import { useFormik } from "formik";
import * as Yup from "yup"
import { httpRequest } from "utils/httpRequest";
import { toast } from 'react-toastify';


const ForgotPassword = () => {

  const [buttonLoading, setButtonLoading] = useState(false);



  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),

  })


  const formik = useFormik({
    initialValues: {
      email: "",

    },
    validationSchema,
    onSubmit: async (values) => {

      setButtonLoading(true)
      try {


        const response = await httpRequest(
          "admin/forgotPassword",
          "POST",
          {
            email: values.email
          },
          {},
          true,
          true
        );
        if (response?.code === 200) {
         
          toast.success("Email sent successfully.")
          formik.resetForm()



        }

      } catch (error) {
        console.log(error);

      } finally {
        setButtonLoading(false)
      }

    }
  })



  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">

          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Forgot Password</small>
            </div >
            <div className="text-center text-muted mb-4">
              Enter the email associated with your account,
              and we'll send you instructions to reset your password.
            </div>
            <Form role="form" onSubmit={formik.handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </InputGroup>

                {formik.touched.email && formik.errors.email && (
                  <div className="text-danger small mt-1">{formik.errors.email}</div>
                )}
              </FormGroup>


              <div className="text-center d-flex align-items-center justify-content-center">
                <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                  {buttonLoading ? <span className="button-loader"></span> : "Send Verification Link"}
                </Button>

              </div>
            </Form>

          </CardBody>
        </Card>

      </Col>
    </>
  );
};

export default ForgotPassword;
